import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class SessionStorageService {
  static NEW_ORDER_FLOW = 'APP_DATA';
  static EXISTING_ORDER_FLOW = 'ORDER_DATA';

  private sessionData = {} as any;
  private readonly STORAGE_KEY: string = SessionStorageService.NEW_ORDER_FLOW;
  constructor() {
    const NEW_ORDER_FLOW_DATA = sessionStorage.getItem(SessionStorageService.NEW_ORDER_FLOW);
    const EXISTING_ORDER_FLOW_DATA = sessionStorage.getItem(SessionStorageService.EXISTING_ORDER_FLOW);
    this.sessionData[SessionStorageService.NEW_ORDER_FLOW] = NEW_ORDER_FLOW_DATA ? JSON.parse(NEW_ORDER_FLOW_DATA) : {};
    this.sessionData[SessionStorageService.EXISTING_ORDER_FLOW] = EXISTING_ORDER_FLOW_DATA ? JSON.parse(EXISTING_ORDER_FLOW_DATA) : {};
  }

  saveData(value: any, STORAGE_KEY = this.STORAGE_KEY): void {
    this.sessionData[STORAGE_KEY] = cloneDeep(value);
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(this.sessionData[STORAGE_KEY]));
  }

  getData(STORAGE_KEY = this.STORAGE_KEY): any {
    return cloneDeep(this.sessionData[STORAGE_KEY] ?? {});
  }

  deleteData(key: string): void {
    delete this.sessionData[key];
    sessionStorage.setItem(this.STORAGE_KEY, JSON.stringify(this.sessionData));
  }

  getAllData(STORAGE_KEY = this.STORAGE_KEY): any {
    return cloneDeep(this.sessionData[STORAGE_KEY] ?? {});
  }

  clearData() {
    this.sessionData = {};
    sessionStorage.removeItem(SessionStorageService.EXISTING_ORDER_FLOW);
    sessionStorage.removeItem(SessionStorageService.NEW_ORDER_FLOW);

  }
}
